import React, { useEffect, useRef, useState } from 'react'
import { useHistory, withRouter, RouteComponentProps } from 'react-router-dom'
import { toast, ToastOptions } from 'react-toastify'

import { Scope } from '@unform/core'
import {
  ResumoDeDocumentosDeSaidaMapper,
  selecaoDeDocumentosParaEnvio,
  UploadDocumentos,
  useRelacaoDeDocumentos
} from 'src/compartilhados'
import { RelacaoDocumentosAlunoCertificacao } from 'src/compartilhados/modulos/gestao-de-documentos/data/relacao-de-documentos-aluno-certificacao.data'
import {
  FormUnform,
  Botao,
  Breadcrumb,
  Cabecalho,
  focarPrimeiroCampoOuEditorComErro,
  IconeBack,
  Link,
  ModalRef,
  SelectOpcao,
  SubTitulo,
  InputUnform,
  Spacer,
  Modal,
  CalendarioUnform,
  ErroLayoutContainer,
  CheckboxUnform,
  AutenticacaoContainer,
  Visao
} from 'src/componentes'
import { SelectUnform } from 'src/componentes/unform/select'
import { SELECT_FORMACAO, SELECT_NACIONALIDADES } from 'src/dados-estaticos'
import { AlunoCertificacaoPayload, CursoCertificacaoPayload } from 'src/dto'
import { SelectUnformComEstilos } from 'src/paginas/aluno/editar-dados/styles'
import { ContainerDadosGrande } from 'src/paginas/professor/meu-cadastro/styles'
import { RotasAlunoCertificacao } from 'src/rotas'
import { Api } from 'src/servicos'
import {
  TipoTurmaCertificacao,
  AlunoCertificacaoSituacao,
  AlunoStatusCertificado,
  DivisaoCursoCertificacao
} from 'src/tipos'
import { ModoPaginaCadastro } from 'src/tipos/genericos'

import { ContainerCertificacao } from '../../styles'
import { AccordionDisciplina } from './componentes/accordion-disciplinas'
import DocumentosAlunoCertificacao, {
  DocumentosAlunoCertificacaoHandles
} from './componentes/documentos/documentos-aluno-certificacao'
import { createSchema } from './schema'
import {
  Container,
  ContainerMain,
  ContainerDadosMedio,
  Conteudo,
  ContainerDados,
  ContainerAcoes,
  FormContainer,
  ContainerLink,
  SecaoPrimaria
} from './styles'
export interface PaginaTurmaCertificacaoProps
  extends RouteComponentProps<{
    id?: string
    tipo?: TipoTurmaCertificacao
  }> {
  modo?: ModoPaginaCadastro
}

function normalizarAlunoCertificacao(
  aluno: AlunoCertificacaoPayload
): AlunoCertificacaoPayload {
  return {
    ...aluno,
    disciplinas:
      aluno.disciplinas?.map(d => ({
        ...d,
        disciplinaId: d.disciplinaId ?? d.id,
        disciplinaNome: d.disciplinaNome ?? d.nome
      })) ?? [],
    disciplinasModulo: aluno.disciplinasModulo?.map(dm => ({
      ...dm,
      disciplinas:
        dm.disciplinas?.map(d => ({
          ...d,
          disciplinaId: d.disciplinaId ?? d.id,
          disciplinaNome: d.disciplinaNome ?? d.nome
        })) ?? []
    }))
  }
}

const PaginaAlunos: React.FC<PaginaTurmaCertificacaoProps> = ({
  match,
  modo
}) => {
  const modalRef = useRef<ModalRef>(null)
  const { visao } = AutenticacaoContainer.useContainer()
  const documentosRef = useRef<DocumentosAlunoCertificacaoHandles>(null)
  const usuario = localStorage.getItem('@ipgs/usuario')
  const usuarioObj = JSON.parse(usuario)
  const [idAluno, setIdAluno] = useState<string>()
  const usuarioId = usuarioObj.id
  const [aluno, definirAluno] = useState<AlunoCertificacaoPayload | undefined>(
    undefined
  )
  const [titulo] = useState(
    `${modo === ModoPaginaCadastro.Inclusao ? 'Inclusão' : 'Edição'} do Aluno`
  )
  const history = useHistory()
  const { documentos, atualizar, reiniciar } = useRelacaoDeDocumentos(
    RelacaoDocumentosAlunoCertificacao
  )
  const [pronto, definirPronto] = useState(true)

  const erroAoEnviarDocumentos = 'Erro ao enviar documentos.'
  const erroAoAtualizarDocumentos = 'Erro ao atualizar documentos.'
  const erroAoEnviarMotivoAlteracaoAprovado = 'Erro ao enviar motivo alteração'

  const toastOptions = { type: 'error' } as ToastOptions
  const [
    cursoTurmaAluno,
    definirCursoTurmaAluno
  ] = useState<CursoCertificacaoPayload>()
  const [carregando, definirCarregando] = useState(false)
  const [opcoesTurma, setOpcoesTurma] = useState<SelectOpcao[]>([])
  const [opcaoTCC, definirOpcaoTCC] = useState(false)
  const [turma, definirTurma] = useState<any>(undefined)

  useEffect(() => {
    if (modo === ModoPaginaCadastro.Edicao) {
      setIdAluno(match.params.id)
    }
  }, [])

  const carregarAluno = async () => {
    try {
      const alunoParaEdicao = await Api.RequisitarAlunoCertificacao(
        match.params.id
      )
      const turma = await Api.RequisitarTurmaCertificacao(
        alunoParaEdicao?.turmaCertificacaoId
      )
      definirTurma(turma)
      const curso = await Api.RequisitarCursoCertificacao(
        turma.cursoCertificacaoId
      )
      definirCursoTurmaAluno(curso)
      definirAluno(normalizarAlunoCertificacao(alunoParaEdicao))
      definirOpcaoTCC(alunoParaEdicao.tcc === 'true')
    } catch (error) {
    } finally {
      definirPronto(true)
    }
  }

  const focarNoPrimeiroErro = (idContexto?: string): void => {
    setTimeout(() => {
      const selecaoDoEditor = '#informacoes-container > #erro-informacoes'
      return focarPrimeiroCampoOuEditorComErro(selecaoDoEditor)(idContexto)
    }, 0)
  }

  useEffect(() => {
    const carregarDados = async () => {
      try {
        const turmas = await Api.RequisitarTodasTurmasCertificacao(
          usuarioId,
          visao
        )
        const opcoesFormatadas = turmas.map((turma: any) => ({
          id: turma.id,
          texto: turma.nome
        }))
        setOpcoesTurma(opcoesFormatadas)

        if (modo === ModoPaginaCadastro.Edicao) {
          const alunoParaEdicao = await Api.RequisitarAlunoCertificacao(
            match.params.id
          )
          definirAluno(normalizarAlunoCertificacao(alunoParaEdicao))
          definirOpcaoTCC(alunoParaEdicao.tcc === 'true')
        }
      } catch (e) {
        // eslint-disable-next-line
        console.error('Erro ao carregar dados do aluno')
      }
    }

    carregarDados()
  }, [usuarioId])

  const uploadDeCriacao = async (
    alunoId: string,
    documentos: UploadDocumentos[]
  ): Promise<void> => {
    try {
      const formulario = ResumoDeDocumentosDeSaidaMapper(documentos)
      const resposta = await Api.EnviarDocumentosAlunoCertificacao(
        alunoId,
        formulario
      )

      if (!resposta) {
        toast(erroAoEnviarDocumentos, toastOptions)
      }
    } catch (erro) {
      toast(erroAoEnviarDocumentos, toastOptions)
    }
  }

  const uploadDeEdicao = async (
    alunoId: string,
    documentos: UploadDocumentos[]
  ): Promise<void> => {
    try {
      const formulario = ResumoDeDocumentosDeSaidaMapper(documentos)
      const resposta = await Api.EditarDocumentosAlunoCertificacao(
        alunoId,
        formulario
      )

      if (resposta) {
        const documentosAprovados = documentos.filter(
          x => x.motivoAlteracaoAprovado
        )

        if (documentosAprovados?.length > 0) {
          try {
            await Api.AlteracaoAprovado(alunoId, documentosAprovados)
          } catch {
            toast(erroAoEnviarMotivoAlteracaoAprovado, toastOptions)
          }
        }
      } else {
        toast(erroAoAtualizarDocumentos, toastOptions)
      }
    } catch (erro) {
      toast(erroAoAtualizarDocumentos, toastOptions)
    }
  }

  const acaoSucesso = async (dados: AlunoCertificacaoPayload) => {
    try {
      definirCarregando(true)
      const { edicoes, criacoes, contador } = selecaoDeDocumentosParaEnvio(
        documentos
      )

      if (modo === ModoPaginaCadastro.Inclusao) {
        const response = await Api.InserirAlunoCertificacao(dados, usuarioId)
        setIdAluno(response.alunoId)

        if (contador !== 0) {
          uploadDeCriacao(response.alunoId, criacoes)
        }
      } else {
        const alunoPayload = {
          ...dados,
          divisao: cursoTurmaAluno?.divisao
        }

        await Api.EditarAlunoCertificacao(
          match.params.id,
          alunoPayload,
          usuarioId
        )

        if (contador !== 0) {
          if (criacoes.length > 0) {
            await uploadDeCriacao(match.params.id, criacoes)
          }

          if (edicoes.length > 0) {
            await uploadDeEdicao(match.params.id, edicoes)
          }
        }

        setIdAluno(match.params.id)
      }

      history.push(RotasAlunoCertificacao.Alunos)
    } finally {
      definirCarregando(false)
    }
  }

  const turmaAlterada = async (opcao: SelectOpcao) => {
    const turma = await Api.RequisitarTurmaCertificacao(opcao?.id)
    definirTurma(turma)
    const curso = await Api.RequisitarCursoCertificacao(
      turma.cursoCertificacaoId
    )
    definirCursoTurmaAluno(curso)
  }

  useEffect(() => {
    if (modo === ModoPaginaCadastro.Edicao && match.params.id) {
      carregarAluno()
    }
  }, [usuarioId, modo, match.params.id])

  const handleDataFinalizacao = (dataFim: any) => {
    if (dataFim) {
      return new Date(dataFim).toLocaleDateString('pt-BR')
    }

    const dataInicio = new Date(turma?.dataInicio)
    const duracao = cursoTurmaAluno?.duracao ?? 0

    const dataFimCalculada = new Date(dataInicio)
    dataFimCalculada.setMonth(dataFimCalculada.getMonth() + duracao)

    return dataFimCalculada.toLocaleDateString('pt-BR')
  }

  const isParceiro = visao === Visao.ParceiroCertificacao

  const tabelaModulosDisciplinas = () => {
    return (
      <>
        {cursoTurmaAluno && (
          <ContainerDados>
            <ContainerDadosGrande>
              {cursoTurmaAluno?.divisao === DivisaoCursoCertificacao.Modulo ? (
                <>
                  {aluno?.disciplinasModulo.map((dm, idxModulo) => (
                    <>
                      <Spacer padding="30px 0px 0px" />
                      <SubTitulo texto={dm.modulo} />

                      {dm?.disciplinas.map((disciplina, idxDisciplina) => {
                        return (
                          <Scope
                            key={`${idxModulo}-${idxDisciplina}`}
                            path={`disciplinasModulo[${idxModulo}].disciplinas[${idxDisciplina}]`}
                          >
                            <InputUnform
                              name="divisao"
                              value={cursoTurmaAluno?.divisao}
                              esconder
                            />
                            <AccordionDisciplina disciplina={disciplina} />
                            <Spacer padding="10px 0px" />
                          </Scope>
                        )
                      })}
                    </>
                  ))}
                </>
              ) : (
                <>
                  {aluno?.disciplinas?.map((disciplina, idx) => {
                    return (
                      <Scope key={`${idx}`} path={`disciplinas[${idx}]`}>
                        <Spacer padding="30px 0px 0px" />
                        <InputUnform
                          name="divisao"
                          value={cursoTurmaAluno?.divisao}
                          esconder
                        />
                        <AccordionDisciplina disciplina={disciplina} />
                      </Scope>
                    )
                  })}
                </>
              )}
            </ContainerDadosGrande>
          </ContainerDados>
        )}
      </>
    )
  }

  return (
    <ContainerCertificacao>
      {pronto ? (
        <Container>
          <ContainerMain>
            <ContainerLink>
              <Link
                texto="Voltar"
                href={RotasAlunoCertificacao.Alunos}
                icone={IconeBack}
              />
            </ContainerLink>
            <Cabecalho>
              <Breadcrumb
                titulo={titulo}
                atalhos={[
                  {
                    texto: 'Acadêmico',
                    acao: () => history.goBack()
                  },
                  {
                    texto: 'Alunos',
                    acao: () => history.goBack()
                  },
                  {
                    texto: titulo
                  }
                ]}
              />
            </Cabecalho>
            <Conteudo>
              <FormContainer>
                <FormUnform
                  key={aluno?.id ?? aluno?.nome}
                  schema={createSchema}
                  dadosIniciais={aluno}
                  acaoSucesso={acaoSucesso}
                  acaoFalha={focarNoPrimeiroErro}
                >
                  <SecaoPrimaria>
                    <SubTitulo texto="Dados do Aluno" />
                    <ContainerDados>
                      <ContainerDadosMedio>
                        <InputUnform
                          name="nome"
                          label="Nome"
                          obrigatorio
                          maxLength={200}
                          disabled={!isParceiro}
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosMedio>
                        <InputUnform
                          name="cpf"
                          label="CPF"
                          maxLength={200}
                          disabled={!isParceiro}
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosMedio>
                        <SelectUnform
                          id="slc_nacionalidade_responsavel"
                          name="nacionalidade"
                          label="Nacionalidade"
                          placeholder="Selecione"
                          opcoes={SELECT_NACIONALIDADES}
                          disabled={!isParceiro}
                        />
                      </ContainerDadosMedio>
                    </ContainerDados>
                    <ContainerDados>
                      <ContainerDadosMedio>
                        <CalendarioUnform
                          className="sm"
                          id="ipt_data_nascimento"
                          name="dataNascimento"
                          label="Data de Nascimento"
                          obrigatorio
                          disabled={!isParceiro}
                        />
                      </ContainerDadosMedio>
                      {/* <ContainerDadosMedio>
                        <TelefoneInputUnform
                          id="ipt_celular"
                          name="celular"
                          label="Celular"
                          // obrigatorio
                        />
                      </ContainerDadosMedio> */}
                      <ContainerDadosMedio>
                        <InputUnform
                          id="ipt_uf"
                          name="uf"
                          label="UF"
                          disabled={!isParceiro}
                          // obrigatorio
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosMedio>
                        <InputUnform
                          id="ipt_cidade"
                          name="cidade"
                          label="Cidade"
                          // obrigatorio
                          maxLength={200}
                          disabled={!isParceiro}
                        />
                      </ContainerDadosMedio>
                    </ContainerDados>
                    <ContainerDados>
                      <ContainerDadosMedio>
                        <SelectUnformComEstilos
                          className="lg"
                          id="formacao"
                          name="formacao"
                          label="Formação"
                          placeholder="Selecione"
                          opcoes={SELECT_FORMACAO}
                          disabled={!isParceiro}
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosMedio>
                        <InputUnform
                          type="text"
                          name="profissao"
                          label="Profissão"
                          maxLength={200}
                          disabled={!isParceiro}
                        />
                      </ContainerDadosMedio>
                    </ContainerDados>
                    <ContainerDados>
                      <ContainerDadosGrande style={{ marginBottom: '20px' }}>
                        <SelectUnform
                          id="slct_alunoTurma"
                          name="turmaCertificacaoId"
                          label="Turma"
                          obrigatorio
                          valorAlterado={turmaAlterada}
                          margemInferior={false}
                          opcoes={opcoesTurma}
                          disabled={
                            modo === ModoPaginaCadastro.Edicao || !isParceiro
                          }
                        />
                      </ContainerDadosGrande>
                    </ContainerDados>
                    <ContainerDados style={{ marginBottom: '20px' }}>
                      <ContainerDadosMedio>
                        <SelectUnform
                          id="slct_situacao"
                          name="situacao"
                          label="Situação"
                          obrigatorio
                          margemInferior={false}
                          disabled={!isParceiro}
                          opcoes={[
                            {
                              id:
                                AlunoCertificacaoSituacao[
                                  AlunoCertificacaoSituacao.Aprovado
                                ],
                              texto:
                                AlunoCertificacaoSituacao[
                                  AlunoCertificacaoSituacao.Aprovado
                                ]
                            },
                            {
                              id:
                                AlunoCertificacaoSituacao[
                                  AlunoCertificacaoSituacao.Reprovado
                                ],
                              texto:
                                AlunoCertificacaoSituacao[
                                  AlunoCertificacaoSituacao.Reprovado
                                ]
                            },
                            {
                              id:
                                AlunoCertificacaoSituacao[
                                  AlunoCertificacaoSituacao.Emandamento
                                ],
                              texto: 'Em Andamento'
                            }
                          ]}
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosMedio>
                        <SelectUnform
                          id="slct_status_certificado"
                          name="statusCertificado"
                          label="Status Certificado"
                          margemInferior={false}
                          disabled={isParceiro}
                          opcoes={[
                            {
                              id:
                                AlunoStatusCertificado[
                                  AlunoStatusCertificado.Aguardando
                                ],
                              texto:
                                AlunoStatusCertificado[
                                  AlunoStatusCertificado.Aguardando
                                ]
                            },
                            {
                              id:
                                AlunoStatusCertificado[
                                  AlunoStatusCertificado.Entregue
                                ],
                              texto:
                                AlunoStatusCertificado[
                                  AlunoStatusCertificado.Entregue
                                ]
                            },
                            {
                              id:
                                AlunoStatusCertificado[
                                  AlunoStatusCertificado.Cursando
                                ],
                              texto:
                                AlunoStatusCertificado[
                                  AlunoStatusCertificado.Cursando
                                ]
                            }
                          ]}
                        />
                      </ContainerDadosMedio>
                    </ContainerDados>
                    <ContainerDados>
                      <ContainerDadosMedio>
                        <CalendarioUnform
                          className="sm"
                          id="ipt_data_entrega_diploma"
                          name="dataEntregaDiploma"
                          label="Data entrega do diploma"
                          disabled={isParceiro}
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosMedio>
                        <CalendarioUnform
                          className="sm"
                          id="ipt_data_colacao_grau"
                          name="dataColacaoGrau"
                          label="Data colação do grau"
                          disabled={!isParceiro}
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosMedio style={{ marginRight: '19px' }}>
                        <InputUnform
                          name="dataFinalizacaoAluno"
                          label="Data finalização aluno"
                          maxLength={200}
                          // value={
                          //   turma?.dataFim
                          //     ? new Date(turma.dataFim).toLocaleDateString(
                          //         'pt-BR'
                          //       )
                          //     : ''
                          // }
                          value={handleDataFinalizacao(turma?.dataFim)}
                          disabled
                        />
                      </ContainerDadosMedio>
                    </ContainerDados>
                    <ContainerDados style={{ marginBottom: '20px' }}>
                      <CheckboxUnform
                        id="slct_tcc"
                        name="tcc"
                        texto={'Adicionar notas de TCC'}
                        checked={opcaoTCC}
                        onChange={() => definirOpcaoTCC(old => !old)}
                        disabled={!isParceiro}
                      />
                    </ContainerDados>
                    {opcaoTCC && (
                      <ContainerDados>
                        <ContainerDadosMedio>
                          <InputUnform
                            name="notaOrientador"
                            label="Nota Orientador"
                            maxLength={200}
                            disabled={!isParceiro}
                          />
                        </ContainerDadosMedio>
                        <ContainerDadosMedio>
                          <InputUnform
                            name="notaBanca"
                            label="Nota Banca"
                            maxLength={200}
                            disabled={!isParceiro}
                          />
                        </ContainerDadosMedio>
                      </ContainerDados>
                    )}
                    <ContainerDados>
                      <ContainerDadosGrande>
                        <ErroLayoutContainer.Provider>
                          <DocumentosAlunoCertificacao
                            ref={documentosRef}
                            alunoCertificacaoId={idAluno}
                            documentos={documentos}
                            atualizar={atualizar}
                            reiniciar={reiniciar}
                          />
                        </ErroLayoutContainer.Provider>
                      </ContainerDadosGrande>
                    </ContainerDados>
                    {tabelaModulosDisciplinas()}
                  </SecaoPrimaria>
                  <Spacer padding="10px 0px" />
                  <ContainerAcoes>
                    <Botao
                      texto="Cancelar"
                      tema="Secundario"
                      type="button"
                      disabled={carregando}
                      onClick={() => modalRef.current?.abrir()}
                    />
                    <Botao
                      type="submit"
                      texto="Salvar"
                      carregando={carregando}
                    />
                  </ContainerAcoes>
                </FormUnform>
              </FormContainer>
            </Conteudo>
          </ContainerMain>
          <Modal
            ref={modalRef}
            backdrop
            id="modal-confirmacao-cancelamento"
            icone={<></>}
            titulo={'Deseja cancelar?'}
            acaoPrimaria={{
              titulo: 'Sim',
              tipo: 'button',
              acao: () => history.goBack()
            }}
            acaoSecundario={{
              titulo: 'Não',
              tipo: 'button',
              acao: () => modalRef.current?.fechar()
            }}
          >
            <p>Selecione uma opção</p>
          </Modal>
        </Container>
      ) : (
        <></>
      )}
    </ContainerCertificacao>
  )
}

export default withRouter(PaginaAlunos)
